import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';

import {AuthService } from '../auth/auth.service';

@Injectable()
export class UserGuard implements CanActivate {

  constructor(private authService: AuthService) { }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    console.log('UserGuard#canActivate called');
    console.log('useruard from', state.url);
    return !!(this.authService.hasValidToken(state.url)); // can pass only if user is logged in
  }
}
